function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { posActions } from '../../../reducers/pos.reducer';
import { modalActions } from '../../../reducers/modal.reducer';
import capFirstLetter from '../../../helpers/capFirstLetter';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Confirm from '../../common/modal/Confirm.modal';
import SelectDepartment from '../../common/form/select/SelectDepartment.react';
import Label from '../../common/form/Label.react';
import AzureBlob from '../../common/AzureBlob.react';
var PosillicoLandingPageArticle = function PosillicoLandingPageArticle(_ref) {
  var _article$articleID, _article$articleID$he, _article$articleID2, _article$logo, _article$logo$assetID, _article$logo2, _article$logo2$assetI, _article$articleID3, _article$articleID4, _article$articleID4$s;
  var article = _ref.article,
    pageID = _ref.pageID,
    pagesAction = _ref.pagesAction,
    addModalAction = _ref.addModalAction;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    subtitle = _useState2[0],
    setSubtitle = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 1),
    department = _useState4[0];
  useEffect(function () {
    setSubtitle(article.subtitle);
  }, [article]);
  var src = (_article$articleID = article.articleID) === null || _article$articleID === void 0 ? void 0 : (_article$articleID$he = _article$articleID.hero[0]) === null || _article$articleID$he === void 0 ? void 0 : _article$articleID$he.filename;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: (_article$articleID2 = article.articleID) === null || _article$articleID2 === void 0 ? void 0 : _article$articleID2.title,
    button: {
      label: 'Delete',
      type: 'delete',
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(Confirm, {
            onConfirm: function onConfirm() {
              pagesAction({
                formData: {
                  pageID: pageID,
                  articleID: article._id
                },
                method: 'delete',
                route: 'posillico-landing-page'
              });
            }
          })
        });
      }
    }
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "pos-mainpage"
  }, /*#__PURE__*/React.createElement(AzureBlob, {
    filename: src,
    className: "pos-mainpage__img"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pos-mainpage__banner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pos-mainpage__banner--logo"
  }, /*#__PURE__*/React.createElement("div", null, (article === null || article === void 0 ? void 0 : (_article$logo = article.logo) === null || _article$logo === void 0 ? void 0 : (_article$logo$assetID = _article$logo.assetID) === null || _article$logo$assetID === void 0 ? void 0 : _article$logo$assetID.filename) && /*#__PURE__*/React.createElement(AzureBlob, {
    filename: article === null || article === void 0 ? void 0 : (_article$logo2 = article.logo) === null || _article$logo2 === void 0 ? void 0 : (_article$logo2$assetI = _article$logo2.assetID) === null || _article$logo2$assetI === void 0 ? void 0 : _article$logo2$assetI.filename
  }))), /*#__PURE__*/React.createElement("div", {
    className: "pos-mainpage__banner--text"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, (_article$articleID3 = article.articleID) === null || _article$articleID3 === void 0 ? void 0 : _article$articleID3.title), /*#__PURE__*/React.createElement("h2", null, "Read more about Posillico ", capFirstLetter(article === null || article === void 0 ? void 0 : article.department), "'s work at ", (_article$articleID4 = article.articleID) === null || _article$articleID4 === void 0 ? void 0 : (_article$articleID4$s = _article$articleID4.sidebar) === null || _article$articleID4$s === void 0 ? void 0 : _article$articleID4$s.location, " >"))))), /*#__PURE__*/React.createElement(Label, {
    label: "Department"
  }), /*#__PURE__*/React.createElement(SelectDepartment, {
    value: department,
    onChange: function onChange(option) {
      pagesAction({
        formData: {
          pageID: pageID,
          articleID: article._id,
          department: option.sValue,
          assetID: option.sLogo
        },
        method: 'put',
        route: 'posillico-landing-page'
      });
    },
    placeholder: "Department"
  })));
};
var mdtp = {
  pagesAction: posActions.pages,
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(PosillicoLandingPageArticle);